module.exports = __webpack_public_path__ + "img/Waiting_01.0bfb5b52.svg";